module.exports = __webpack_public_path__ + "b597af29f659834c0139858a214ed108.svg";